<div class="topbar" *ngIf="!isFilter">
  <h4 class="topbar-title">
    Supplier<span class="icon-help-1 ml-15" [tooltip]="'Select from the list of suppliers below'" tooltipPlacement="top"></span>
  </h4>
  <div class="right-icons">
    <a tooltip="Create a new supplier" tooltipPlacement="top" tabindex="0" (keyup.enter)="onClickCreate()" (click)="onClickCreate()"
      ><span class="icon-add"></span
    ></a>
    <a
      tooltip="Select Suppliers from a file"
      tooltipPlacement="top"
      tabindex="0"
      (keyup.enter)="uploadExcelIconClick($event)"
      (click)="uploadExcelIconClick($event)"
      ><span class="icon-import"></span
    ></a>
  </div>
</div>

<div class="topbar-search" *ngIf="!isFilter">
  <input type="text" class="form-control select-input" placeholder="Select suppliers" [value]="searchQuery" [formControl]="searchControl" pm-ignore />
  <span class="icon-search search-icon"></span>
  <a class="attribute-filter-button" role="button" tooltip="Filter by attributes" tooltipPlacement="top">
    <i class="icon-filter-1" [ngClass]="{ applied: isAttributeFilterSelected() }"></i>
  </a>
  <div class="attribute-options px-10 py-10">
    <div
      class="d-flex justify-content-between mt-10 mb-20"
      tabindex="0"
      (keyup.enter)="onUnselectAllAttributeFilter()"
      (click)="onUnselectAllAttributeFilter()">
      <label class="text-neutral-n6">Attributes</label>
      <label class="cp">Clear</label>
    </div>
    <div
      tabindex="0"
      (keyup.enter)="onFilterAttributeClick(attribute)"
      class="d-flex justify-content-start align-items-center my-10 gap-10"
      [ngClass]="{ 'pe-none text-neutral-n6': !attribute.isEnabled }"
      *ngFor="let attribute of attributeFilterModel"
      (click)="onFilterAttributeClick(attribute)">
      <input class="form-check-input" type="checkbox" [(ngModel)]="attribute.isSelected" />
      <label class="d-flex justify-content-start align-items-center gap-10 cp">
        <span [ngClass]="attribute.icon"></span>
        {{ attribute.label }}
      </label>
    </div>
  </div>
</div>

<div *ngIf="isFilter" class="filter-input-section d-flex justify-space-between align-items-center">
  <input placeholder="Search suppliers" class="form-control" [value]="searchQuery" [formControl]="searchControl" type="text" pm-ignore />
  <span class="icon-search position-absolute"></span>
  <span tabindex="0" (keyup.enter)="onDeleteFilterClick()" class="far fa-trash-alt" (click)="onDeleteFilterClick()"></span>
</div>

<ul class="nav nav-tabs" id="myTab" role="tablist" *ngIf="!isFilter">
  <li class="nav-item" role="presentation">
    <button
      (click)="onChangeTab()"
      class="nav-link active"
      id="all1-tab"
      data-bs-toggle="tab"
      data-bs-target="#all1"
      type="button"
      role="tab"
      aria-controls="all1"
      aria-selected="true">
      All
    </button>
  </li>
  <li class="nav-item" role="presentation">
    <button
      (click)="onChangeTab()"
      class="nav-link"
      id="fav1-tab"
      data-bs-toggle="tab"
      data-bs-target="#fav1"
      type="button"
      role="tab"
      aria-controls="fav1"
      aria-selected="false">
      Favourites
      <span *ngIf="getFavouriteModels().length as favouriteCount">({{ favouriteCount }})</span>
    </button>
  </li>
  <li class="nav-item" role="presentation">
    <button
      (click)="onChangeTab()"
      class="nav-link"
      id="selected1-tab"
      data-bs-toggle="tab"
      data-bs-target="#selected1"
      type="button"
      role="tab"
      aria-controls="selected1"
      aria-selected="false">
      Selected
      <span *ngIf="getSelectedModels().length as selectedCount">({{ selectedCount }})</span>
    </button>
  </li>
</ul>

<div class="supply-wrapper" [ngClass]="{ restrict: isFilter }" #elWrapper>
  <div class="tab-content" id="myTabContent" [ngClass]="{ 'cn-wrapper': isFilter }">
    <div *ngIf="loading" class="d-flex justify-content-center align-items-center py-30">
      <div class="loader"></div>
    </div>
    <div *ngIf="!loading" class="tab-pane mix-select-box fade show active" id="all1" role="tabpanel" aria-labelledby="all1-tab">
      <div class="list-row" tabindex="0" (keyup.enter)="onClickToggleAll()" (click)="onClickToggleAll()">
        <div class="input-check">
          <input class="form-check-input" type="checkbox" [(ngModel)]="toggleAll" [disabled]="selectAllDisabled" />
        </div>
        <div class="text">Select all</div>
        <div class="actions"></div>
      </div>
      <cdk-virtual-scroll-viewport
        itemSize="30"
        [style.height.px]="30 * rowsVisible"
        (scrolledIndexChange)="onScrolledIndexChange($event)"
        #scrollViewportAll>
        <div
          tabindex="0"
          (keyup.enter)="toggle(c); $event.stopPropagation()"
          class="list-row"
          *cdkVirtualFor="let c of models"
          (click)="toggle(c); $event.stopPropagation()">
          <div class="input-check">
            <input
              class="form-check-input"
              type="checkbox"
              [disabled]="!c.selected && !myConnections && !c.online"
              [ngModel]="c.selected"
              [ngModelOptions]="{ standalone: true }" />
          </div>
          <div
            class="text"
            [ngClass]="{ cp: c.online || isFilter, 'text-neutral-n6': !c.online && !isFilter }"
            [tooltip]="getTooltip(c)"
            tooltipPlacement="top">
            {{ c.title }} <span class="category" [ngClass]="c.online ? 'category-online' : 'category-offline'">{{ c.routeType }}</span>
          </div>
          <div class="actions">
            @if (!c.online) {
              <a
                class="offline-session-link"
                tabindex="0"
                tooltip="View session status"
                tooltipPlacement="top"
                (click)="onOfflineSessionClick(c, $event)"
                (keyup.enter)="onOfflineSessionClick(c, $event)"
                ><span class="icon-external"></span
              ></a>
            }

            <span
              [tooltip]="getAttributeName(attribute)"
              tooltipPlacement="top"
              *ngFor="let attribute of c.attributes"
              class="icon"
              [ngClass]="getAttributeIcon(attribute)"></span>

            @if (!isFilter) {
              <a
                tabindex="0"
                (keyup.enter)="onFavChange(c); $event.stopPropagation()"
                class="icon-favourite-wrapper"
                (click)="onFavChange(c); $event.stopPropagation()">
                <span class="icon-favourite" [ngClass]="{ marked: c.isFavourite }"></span
              ></a>
            }
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>

    <div class="tab-pane mix-select-box fade" id="fav1" role="tabpanel" aria-labelledby="fav-1tab" *ngIf="favModels">
      <div
        tabindex="0"
        (keyup.enter)="onClickToggleAllFavorites()"
        *ngIf="favModels.length > 0"
        class="list-row"
        (click)="onClickToggleAllFavorites()">
        <div class="input-check">
          <input class="form-check-input" type="checkbox" [(ngModel)]="toggleAllFavourites" />
        </div>
        <div class="text">Select all</div>
        <div class="actions"></div>
      </div>
      <cdk-virtual-scroll-viewport
        itemSize="30"
        [style.height.px]="30 * rowsVisible"
        (scrolledIndexChange)="onScrolledIndexChange($event)"
        #scrollViewportFavorites>
        <div
          tabindex="0"
          (keyup.enter)="toggle(c); $event.stopPropagation()"
          class="list-row"
          *cdkVirtualFor="let c of favModels"
          (click)="toggle(c); $event.stopPropagation()"
          [hidden]="!c.isFavourite">
          <div class="input-check">
            <input
              class="form-check-input"
              type="checkbox"
              [disabled]="!c.selected && !myConnections && !c.online"
              [ngModel]="c.selected"
              [ngModelOptions]="{ standalone: true }" />
          </div>
          <div
            class="text"
            [ngClass]="{ cp: c.online || isFilter, 'text-neutral-n6': !c.online && !isFilter }"
            [tooltip]="getTooltip(c)"
            tooltipPlacement="top">
            {{ c.title }} <span class="category" [ngClass]="c.online ? 'category-online' : 'category-offline'">{{ c.routeType }}</span>
          </div>
          @if (!isFilter) {
            <div class="actions">
              @if (!c.online) {
                <a
                  class="offline-session-link"
                  tabindex="0"
                  tooltip="View session status"
                  tooltipPlacement="top"
                  (click)="onOfflineSessionClick(c, $event)"
                  (keyup.enter)="onOfflineSessionClick(c, $event)"
                  ><span class="icon-external"></span
                ></a>
              }

              <span
                [tooltip]="getAttributeName(attribute)"
                tooltipPlacement="top"
                *ngFor="let attribute of c.attributes"
                class="icon"
                [ngClass]="getAttributeIcon(attribute)"></span>
              <a
                tabindex="0"
                (keyup.enter)="onFavChange(c); $event.stopPropagation()"
                class="icon-favourite-wrapper"
                (click)="onFavChange(c); $event.stopPropagation()">
                <span class="icon-favourite marked"></span
              ></a>
            </div>
          }
        </div>
        <div class="list-row text-center mt-20 text-neutral-n6" *ngIf="favModels.length === 0">No Favourites</div>
      </cdk-virtual-scroll-viewport>
    </div>

    <div
      class="tab-pane mix-select-box fade"
      id="selected1"
      role="tabpanel"
      aria-labelledby="selected1-tab"
      *ngIf="getSelectedModels() as selectedModels">
      <div tabindex="0" (keyup.enter)="onDeleteFilterClick()" class="list-row" (click)="onDeleteFilterClick()" *ngIf="selectedModels.length">
        <div class="input-check">
          <input class="form-check-input" type="checkbox" checked />
        </div>
        <div class="text">Clear all</div>
      </div>
      <cdk-virtual-scroll-viewport itemSize="30" [style.height.px]="30 * rowsVisible" #scrollViewportSelected>
        <div
          tabindex="0"
          (keyup.enter)="toggle(c); $event.stopPropagation()"
          class="list-row"
          *cdkVirtualFor="let c of selectedModels"
          (click)="toggle(c); $event.stopPropagation()">
          <div class="input-check">
            <input
              class="form-check-input"
              type="checkbox"
              [disabled]="!c.selected && !myConnections && !c.online"
              [ngModel]="c.selected"
              [ngModelOptions]="{ standalone: true }" />
          </div>
          <div
            class="text"
            [ngClass]="{ cp: c.online || isFilter, 'text-neutral-n6': !c.online && !isFilter }"
            [tooltip]="getTooltip(c)"
            tooltipPlacement="top">
            {{ c.title }} <span class="category" [ngClass]="c.online ? 'category-online' : 'category-offline'">{{ c.routeType }}</span>
          </div>
          <div *ngIf="!isFilter" class="actions">
            <a
              *ngIf="!c.online"
              class="offline-session-link"
              tabindex="0"
              tooltip="View session status"
              tooltipPlacement="top"
              (click)="onOfflineSessionClick(c, $event)"
              (keyup.enter)="onOfflineSessionClick(c, $event)"
              ><span class="icon-external"></span
            ></a>
            <span
              [tooltip]="getAttributeName(attribute)"
              tooltipPlacement="top"
              *ngFor="let attribute of c.attributes"
              class="icon"
              [ngClass]="getAttributeIcon(attribute)"></span>
            <a
              tabindex="0"
              (keyup.enter)="onFavChange(c); $event.stopPropagation()"
              class="icon-favourite-wrapper"
              (click)="onFavChange(c); $event.stopPropagation()">
              <span class="icon-favourite" [ngClass]="{ marked: c.isFavourite }"></span
            ></a>
          </div>
        </div>
        <div class="list-row" *ngIf="!selectedModels.length">
          <p class="text-center mt-20 text-neutral-n6">No suppliers selected</p>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>
</div>

<ng-template #createModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Create supplier</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body create-connection">
    <app-supplier-form (afterSave)="onAfterSave()"></app-supplier-form>
  </div>
</ng-template>

<ng-template #connectionImportModalTpl let-dialogRefConnection="dialogRef">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Import suppliers from file</h3>
      <button type="button" class="btn-close" (click)="dialogRefConnection.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="alert alert-primary">
      Upload an xlsx file with the list of suppliers to be selected from this menu. This action will select only the existing suppliers that are
      online.
      <br /><br />You need to provide the supplier name in the first column and the route type in the second column.
    </div>
    <app-routes-import [fileList]="importConnectionFileList" (import)="onImportConnection($event)"></app-routes-import>
  </div>
</ng-template>

<ng-template #selectSessionModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Select a Session</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div [hidden]="!loading" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <div class="search-bar">
      <p class="text-neutral-n6">Select to which SMPP session you would like to associate the new supplier</p>
      <input class="form-control" type="text" placeholder="Search SMPP session ..." [formControl]="sessionSearchControl" pm-ignore />
    </div>
    <table class="session-table w-100">
      <thead>
        <tr>
          <th>Session ID</th>
          <th>Login</th>
          <th>Host</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!availableSessions.length">
          <td style="height: 100px" colspan="3" class="text-center">No sessions available</td>
        </tr>
        <tr
          *ngFor="let session of availableSessions"
          class="session-row cp"
          [ngClass]="{ active: selectedSession?.id === session.id }"
          (click)="selectedSession = session">
          <td>{{ session.id }}</td>
          <td>{{ session.systemId }}</td>
          <td>
            {{ session.hostIp }}:{{ session.hostPort }}
            <span class="fas fa-circle fs-6" [ngClass]="{ 'text-success-s2': session.online, 'text-error-r2': !session.online }"></span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer mt-15">
    <div class="button-holder d-flex justify-content-between mt-15">
      <button class="btn btn-outline-dark px-15" (click)="dialogRef.close(false)">Cancel</button>
      <button class="btn btn-primary px-15" (click)="selectSupplier()">Next</button>
    </div>
  </div>
</ng-template>
